import { gql } from "@apollo/client";

const LOD_SELECTION = `
  id
  message
  title
  enum_values {
    id
    level_code
    description
    is_default
    value
    sequence_no
  }
`;

export const GET_PROJECT_DESIGN_SCOPE_LEVEL_OF_DETAIL = gql`
  query GetProjectDesignScopeLevelOfDetail {
    get_project_design_scope_level_of_detail {
      ${LOD_SELECTION}
    }
  }
`;

export const GET_SUBSCRIPTION_DESIGN_SCOPE_LEVEL_OF_DETAIL = gql`
  query GetSubscriptionDesignScopeLevelOfDetail {
    get_subscription_design_scope_level_of_detail {
      ${LOD_SELECTION}
    }
  }
`;

export const UPDATE_PROJECT_DESIGN_SCOPE_LEVEL_OF_DETAIL = gql`
  mutation UpdateProjectDesignScopeLevelOfDetail(
    $enum_values: [design_scope_level_of_detail_enum_value_input!]!
  ) {
    update_project_design_scope_level_of_detail(enum_values: $enum_values) {
      message
    }
  }
`;

export const UPDATE_SUBSCRIPTION_DESIGN_SCOPE_LEVEL_OF_DETAIL = gql`
  mutation UpdateSubscriptionDesignScopeLevelOfDetail(
    $enum_values: [design_scope_level_of_detail_enum_value_input!]!
  ) {
    update_subscription_design_scope_level_of_detail(
      enum_values: $enum_values
    ) {
      message
    }
  }
`;

const RESPONSIBILITY_ENUM_VALUES = `
  enum_values {
    id
    name
    description
  }
`;

export const GET_PROJECT_DESIGN_SCOPE_RESPONSIBILITY = gql`
  query GetProjectDesignScopeResponsibility {
    get_project_design_scope_responsibility {
      project_id
      ${RESPONSIBILITY_ENUM_VALUES}
    }
  }
`;

export const GET_SUBSCRIPTION_DESIGN_SCOPE_RESPONSIBILITY = gql`
  query GetSubscriptionDesignScopeResponsibility {
    get_subscription_design_scope_responsibility {
      subscription_id
      ${RESPONSIBILITY_ENUM_VALUES}
    }
  }
`;

export const ADD_PROJECT_DESIGN_SCOPE_RESPONSIBILITY = gql`
  mutation AddProjectDesignScopeResponsibility(
    $name: String!
    $description: String
  ) {
    add_project_design_scope_responsibility(
      name: $name
      description: $description
    ) {
      message
      result {
        ${RESPONSIBILITY_ENUM_VALUES}
      }
    }
  }
`;

export const ADD_SUBSCRIPTION_DESIGN_SCOPE_RESPONSIBILITY = gql`
  mutation AddSubscriptionDesignScopeResponsibility(
    $name: String!
    $description: String
  ) {
    add_subscription_design_scope_responsibility(
      name: $name
      description: $description
    ) {
      message
      result {
        ${RESPONSIBILITY_ENUM_VALUES}
      }
    }
  }
`;

export const UPDATE_PROJECT_DESIGN_SCOPE_RESPONSIBILITY = gql`
  mutation UpdateProjectDesignScopeResponsibility(
    $enum_values: [design_scope_responsibility_enum_value_input!]!
  ) {
    update_project_design_scope_responsibility(enum_values: $enum_values) {
      message
      result {
        ${RESPONSIBILITY_ENUM_VALUES}
      }
    }
  }
`;

export const UPDATE_SUBSCRIPTION_DESIGN_SCOPE_RESPONSIBILITY = gql`
  mutation UpdateSubscriptionDesignScopeResponsibility(
    $enum_values: [design_scope_responsibility_enum_value_input!]!
  ) {
    update_subscription_design_scope_responsibility(enum_values: $enum_values) {
      message
      result {
        ${RESPONSIBILITY_ENUM_VALUES}
      }
    }
  }
`;

export const DELETE_PROJECT_DESIGN_SCOPE_RESPONSIBILITY = gql`
  mutation DeleteProjectDesignScopeResponsibility($id: Int!) {
    delete_project_design_scope_responsibility(id: $id) {
      message
      result {
        ${RESPONSIBILITY_ENUM_VALUES}
      }
    }
  }
`;

export const DELETE_SUBSCRIPTION_DESIGN_SCOPE_RESPONSIBILITY = gql`
  mutation DeleteSubscriptionDesignScopeResponsibility($id: Int!) {
    delete_subscription_design_scope_responsibility(id: $id) {
      message
      result {
        ${RESPONSIBILITY_ENUM_VALUES}
      }
    }
  }
`;
